unit PrjFormWirkungsKurven;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, PrjFormDefault, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCStateManager, VCL.TMSFNCResponsiveManager, VCL.TMSFNCTrackBar, VCL.TMSFNCSpinEdit, Vcl.Graphics,
  Vcl.StdCtrls, VCL.TMSFNCButton, Vcl.Controls, WEBLib.StdCtrls, VCL.TMSFNCCustomControl, VCL.TMSFNCPanel, VCL.TMSFNCChart,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, VCL.TMSFNCListBox, VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGrid, Vcl.Imaging.GIFImg, Types, Vcl.Grids, WEBLib.Grids;

type
  TPrjFormsWirkungsKurven = class(TPrjFormsDefault)
    pnChart: TTMSFNCPanel;
    pnChartDataGrid: TTMSFNCPanel;
    pnKurvenAuswahl: TTMSFNCPanel;
    chartWirkungskurven: TTMSFNCChart;
    lbKurvenauswahl: TTMSFNCListBox;
    strgWirkungsKurvenData: TStringGrid;
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  PrjFormsWirkungsKurven: TPrjFormsWirkungsKurven;

implementation

{$R *.dfm}

procedure TPrjFormsWirkungsKurven.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnChart := TTMSFNCPanel.Create(Self);
  pnChartDataGrid := TTMSFNCPanel.Create(Self);
  strgWirkungsKurvenData := TStringGrid.Create(Self);
  pnKurvenAuswahl := TTMSFNCPanel.Create(Self);
  lbKurvenauswahl := TTMSFNCListBox.Create(Self);
  chartWirkungskurven := TTMSFNCChart.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  pnChart.BeforeLoadDFMValues;
  pnChartDataGrid.BeforeLoadDFMValues;
  strgWirkungsKurvenData.BeforeLoadDFMValues;
  pnKurvenAuswahl.BeforeLoadDFMValues;
  lbKurvenauswahl.BeforeLoadDFMValues;
  chartWirkungskurven.BeforeLoadDFMValues;
  try
    WaitMessage.Picture.LoadFromFile('PrjFormWirkungsKurven.WaitMessage.Picture.gif');
    pnChart.SetParentComponent(Self);
    pnChart.Name := 'pnChart';
    pnChart.Left := 0;
    pnChart.Top := 0;
    pnChart.Width := 1376;
    pnChart.Height := 864;
    pnChart.Align := alClient;
    pnChart.ParentDoubleBuffered := False;
    pnChart.DoubleBuffered := True;
    pnChart.TabOrder := 1;
    pnChart.SectionsAppearance.Font.Charset := DEFAULT_CHARSET;
    pnChart.SectionsAppearance.Font.Color := clWindowText;
    pnChart.SectionsAppearance.Font.Height := -11;
    pnChart.SectionsAppearance.Font.Name := 'Segoe UI';
    pnChart.SectionsAppearance.Font.Style := [];
    pnChart.Header.Text := 'Wirkungskurven (Chart)';
    pnChart.Header.HorizontalTextAlign := gtaLeading;
    pnChart.Header.Font.Charset := DEFAULT_CHARSET;
    pnChart.Header.Font.Color := 4539717;
    pnChart.Header.Font.Height := -13;
    pnChart.Header.Font.Name := 'Segoe UI';
    pnChart.Header.Font.Style := [fsBold];
    pnChart.Header.Fill.Color := 16380654;
    pnChart.Header.Stroke.Kind := gskNone;
    pnChart.Footer.Text := 'Footer';
    pnChart.Footer.Font.Charset := DEFAULT_CHARSET;
    pnChart.Footer.Font.Color := 4539717;
    pnChart.Footer.Font.Height := -13;
    pnChart.Footer.Font.Name := 'Segoe UI';
    pnChart.Footer.Font.Style := [];
    pnChart.Footer.Fill.Color := 16380654;
    pnChartDataGrid.SetParentComponent(pnChart);
    pnChartDataGrid.Name := 'pnChartDataGrid';
    pnChartDataGrid.Left := 936;
    pnChartDataGrid.Top := 28;
    pnChartDataGrid.Width := 440;
    pnChartDataGrid.Height := 836;
    pnChartDataGrid.Align := alRight;
    pnChartDataGrid.ParentDoubleBuffered := False;
    pnChartDataGrid.DoubleBuffered := True;
    pnChartDataGrid.TabOrder := 0;
    pnChartDataGrid.SectionsAppearance.Font.Charset := DEFAULT_CHARSET;
    pnChartDataGrid.SectionsAppearance.Font.Color := clWindowText;
    pnChartDataGrid.SectionsAppearance.Font.Height := -11;
    pnChartDataGrid.SectionsAppearance.Font.Name := 'Segoe UI';
    pnChartDataGrid.SectionsAppearance.Font.Style := [];
    pnChartDataGrid.Header.Text := 'Chart Daten';
    pnChartDataGrid.Header.HorizontalTextAlign := gtaLeading;
    pnChartDataGrid.Header.Font.Charset := DEFAULT_CHARSET;
    pnChartDataGrid.Header.Font.Color := 4539717;
    pnChartDataGrid.Header.Font.Height := -13;
    pnChartDataGrid.Header.Font.Name := 'Segoe UI';
    pnChartDataGrid.Header.Font.Style := [fsBold];
    pnChartDataGrid.Header.Fill.Color := 16380654;
    pnChartDataGrid.Header.Stroke.Kind := gskNone;
    pnChartDataGrid.Footer.Text := 'Footer';
    pnChartDataGrid.Footer.Font.Charset := DEFAULT_CHARSET;
    pnChartDataGrid.Footer.Font.Color := 4539717;
    pnChartDataGrid.Footer.Font.Height := -13;
    pnChartDataGrid.Footer.Font.Name := 'Segoe UI';
    pnChartDataGrid.Footer.Font.Style := [];
    pnChartDataGrid.Footer.Fill.Color := 16380654;
    strgWirkungsKurvenData.SetParentComponent(pnChartDataGrid);
    strgWirkungsKurvenData.Name := 'strgWirkungsKurvenData';
    strgWirkungsKurvenData.Left := 32;
    strgWirkungsKurvenData.Top := 152;
    strgWirkungsKurvenData.Width := 361;
    strgWirkungsKurvenData.Height := 433;
    strgWirkungsKurvenData.ColCount := 3;
    strgWirkungsKurvenData.RowCount := 10;
    strgWirkungsKurvenData.TabOrder := 0;
    strgWirkungsKurvenData.ElementFont := efCSS;
    strgWirkungsKurvenData.RangeEdit.Max := 100.000000000000000000;
    strgWirkungsKurvenData.RangeEdit.Step := 1.000000000000000000;
    strgWirkungsKurvenData.HeightPercent := 100.000000000000000000;
    strgWirkungsKurvenData.WidthPercent := 100.000000000000000000;
    pnKurvenAuswahl.SetParentComponent(pnChart);
    pnKurvenAuswahl.Name := 'pnKurvenAuswahl';
    pnKurvenAuswahl.Left := 0;
    pnKurvenAuswahl.Top := 28;
    pnKurvenAuswahl.Width := 233;
    pnKurvenAuswahl.Height := 836;
    pnKurvenAuswahl.Align := alLeft;
    pnKurvenAuswahl.ParentDoubleBuffered := False;
    pnKurvenAuswahl.DoubleBuffered := True;
    pnKurvenAuswahl.TabOrder := 1;
    pnKurvenAuswahl.SectionsAppearance.Font.Charset := DEFAULT_CHARSET;
    pnKurvenAuswahl.SectionsAppearance.Font.Color := clWindowText;
    pnKurvenAuswahl.SectionsAppearance.Font.Height := -11;
    pnKurvenAuswahl.SectionsAppearance.Font.Name := 'Segoe UI';
    pnKurvenAuswahl.SectionsAppearance.Font.Style := [];
    pnKurvenAuswahl.Header.Text := 'Kurvenauswahl';
    pnKurvenAuswahl.Header.HorizontalTextAlign := gtaLeading;
    pnKurvenAuswahl.Header.Font.Charset := DEFAULT_CHARSET;
    pnKurvenAuswahl.Header.Font.Color := 4539717;
    pnKurvenAuswahl.Header.Font.Height := -13;
    pnKurvenAuswahl.Header.Font.Name := 'Segoe UI';
    pnKurvenAuswahl.Header.Font.Style := [fsBold];
    pnKurvenAuswahl.Header.Fill.Color := 16380654;
    pnKurvenAuswahl.Header.Stroke.Kind := gskNone;
    pnKurvenAuswahl.Footer.Text := 'Footer';
    pnKurvenAuswahl.Footer.Font.Charset := DEFAULT_CHARSET;
    pnKurvenAuswahl.Footer.Font.Color := 4539717;
    pnKurvenAuswahl.Footer.Font.Height := -13;
    pnKurvenAuswahl.Footer.Font.Name := 'Segoe UI';
    pnKurvenAuswahl.Footer.Font.Style := [];
    pnKurvenAuswahl.Footer.Fill.Color := 16380654;
    lbKurvenauswahl.SetParentComponent(pnKurvenAuswahl);
    lbKurvenauswahl.Name := 'lbKurvenauswahl';
    lbKurvenauswahl.Left := 0;
    lbKurvenauswahl.Top := 28;
    lbKurvenauswahl.Width := 233;
    lbKurvenauswahl.Height := 808;
    lbKurvenauswahl.Align := alClient;
    lbKurvenauswahl.ParentDoubleBuffered := False;
    lbKurvenauswahl.DoubleBuffered := True;
    lbKurvenauswahl.TabOrder := 0;
    lbKurvenauswahl.Stroke.Color := clDarkgray;
    lbKurvenauswahl.ItemsAppearance.Font.Charset := DEFAULT_CHARSET;
    lbKurvenauswahl.ItemsAppearance.Font.Color := 8026746;
    lbKurvenauswahl.ItemsAppearance.Font.Height := -11;
    lbKurvenauswahl.ItemsAppearance.Font.Name := 'Segoe UI';
    lbKurvenauswahl.ItemsAppearance.Font.Style := [];
    lbKurvenauswahl.ItemsAppearance.SelectedFill.Color := 16578806;
    lbKurvenauswahl.ItemsAppearance.SelectedStroke.Color := 15702829;
    lbKurvenauswahl.ItemsAppearance.SelectedStroke.Width := 2.000000000000000000;
    lbKurvenauswahl.ItemsAppearance.FixedHeight := 25.000000000000000000;
    lbKurvenauswahl.ItemsAppearance.ShowFocus := False;
    lbKurvenauswahl.DefaultItem.TextColor := 4539717;
    lbKurvenauswahl.DefaultItem.SelectedTextColor := 4539717;
    lbKurvenauswahl.Items.Clear;
    with lbKurvenauswahl.Items.Add do
    begin
      Text := 'Bugfix 376';
      TextColor := 4539717;
      SelectedTextColor := 4539717;
    end;
    with lbKurvenauswahl.Items.Add do
    begin
      Text := 'Bugfix 378';
      TextColor := 4539717;
      SelectedTextColor := 4539717;
    end;
    with lbKurvenauswahl.Items.Add do
    begin
      Text := 'Customer Update';
      TextColor := 4539717;
      SelectedTextColor := 4539717;
    end;
    with lbKurvenauswahl.Items.Add do
    begin
      Text := 'Install New server';
      TextColor := 4539717;
      SelectedTextColor := 4539717;
    end;
    with lbKurvenauswahl.Items.Add do
    begin
      Text := 'Meeting: Next Phase';
      TextColor := 4539717;
      SelectedTextColor := 4539717;
    end;
    with lbKurvenauswahl.Items.Add do
    begin
      Text := 'Release Planning';
      TextColor := 4539717;
      SelectedTextColor := 4539717;
    end;
    lbKurvenauswahl.Header.Text := 'Kurvenauswahl';
    lbKurvenauswahl.Header.Fill.Color := 16380654;
    lbKurvenauswahl.Header.Font.Charset := DEFAULT_CHARSET;
    lbKurvenauswahl.Header.Font.Color := 4539717;
    lbKurvenauswahl.Header.Font.Height := -13;
    lbKurvenauswahl.Header.Font.Name := 'Segoe UI';
    lbKurvenauswahl.Header.Font.Style := [fsBold];
    lbKurvenauswahl.Header.Stroke.Kind := gskNone;
    lbKurvenauswahl.Header.Size := 36.000000000000000000;
    lbKurvenauswahl.Header.SortIndicatorColor := clSteelblue;
    chartWirkungskurven.SetParentComponent(pnChart);
    chartWirkungskurven.Name := 'chartWirkungskurven';
    chartWirkungskurven.Left := 233;
    chartWirkungskurven.Top := 28;
    chartWirkungskurven.Width := 703;
    chartWirkungskurven.Height := 836;
    chartWirkungskurven.Appearance.ColorList.Clear;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 16105559;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 5644279;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 7936771;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 12275349;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 1296366;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 4350195;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 16544551;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 5820321;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 10922240;
    end;
    with chartWirkungskurven.Appearance.ColorList.Add do
    begin
      Color := 16376965;
    end;
    chartWirkungskurven.Appearance.GlobalFont.Color := -1;
    chartWirkungskurven.Appearance.GlobalFont.Scale := 1.000000000000000000;
    chartWirkungskurven.Appearance.GlobalFont.Style := [];
    chartWirkungskurven.Appearance.ColorScheme := ccsColorList;
    chartWirkungskurven.Appearance.MonochromeColor := clSteelblue;
    chartWirkungskurven.ClickMargin := 10.000000000000000000;
    chartWirkungskurven.Legend.Fill.Color := clGhostwhite;
    chartWirkungskurven.Legend.Stroke.Color := clGray;
    chartWirkungskurven.Legend.Font.Charset := DEFAULT_CHARSET;
    chartWirkungskurven.Legend.Font.Color := clWindowText;
    chartWirkungskurven.Legend.Font.Height := -11;
    chartWirkungskurven.Legend.Font.Name := 'Segoe UI';
    chartWirkungskurven.Legend.Font.Style := [];
    chartWirkungskurven.Legend.Left := 10.000000000000000000;
    chartWirkungskurven.Legend.Top := 10.000000000000000000;
    chartWirkungskurven.Stroke.Color := clGray;
    chartWirkungskurven.SeriesMargins.Left := 0;
    chartWirkungskurven.SeriesMargins.Top := 0;
    chartWirkungskurven.SeriesMargins.Right := 0;
    chartWirkungskurven.SeriesMargins.Bottom := 0;
    chartWirkungskurven.Series.Clear;
    with chartWirkungskurven.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      Fill.Color := 16105559;
      LegendText := 'Series 0';
      Labels.Fill.Color := clGhostwhite;
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -11;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.2f';
      Labels.OffsetY := -10.000000000000000000;
      Labels.Stroke.Color := clGray;
      Markers.Fill.Color := 16105559;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 8020012;
      Markers.Visible := True;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      MaxYOffsetPercentage := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Points.Clear;
      with Points.Add do
      begin
        YValue := 24.000000000000000000;
        YValueSecond := 9.000000000000000000;
        YValueVariable := 24.000000000000000000;
        YValueLow := 1.000000000000000000;
        YValueClose := 1.000000000000000000;
        YValueHigh := 24.000000000000000000;
        YValueOpen := 11.000000000000000000;
        YValueMedian := 19.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 1.000000000000000000;
        YValue := 68.000000000000000000;
        YValueSecond := 51.000000000000000000;
        YValueVariable := 68.000000000000000000;
        YValueLow := 35.000000000000000000;
        YValueClose := 67.000000000000000000;
        YValueHigh := 68.000000000000000000;
        YValueOpen := 62.000000000000000000;
        YValueMedian := 71.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 2.000000000000000000;
        YValue := 31.000000000000000000;
        YValueSecond := 14.000000000000000000;
        YValueVariable := 31.000000000000000000;
        YValueLow := 12.000000000000000000;
        YValueClose := 29.000000000000000000;
        YValueHigh := 31.000000000000000000;
        YValueOpen := 26.000000000000000000;
        YValueMedian := 30.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 3.000000000000000000;
        YValue := 53.000000000000000000;
        YValueSecond := 34.000000000000000000;
        YValueVariable := 53.000000000000000000;
        YValueLow := 24.000000000000000000;
        YValueClose := 40.000000000000000000;
        YValueHigh := 53.000000000000000000;
        YValueOpen := 51.000000000000000000;
        YValueMedian := 55.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 4.000000000000000000;
        YValue := 37.000000000000000000;
        YValueSecond := 27.000000000000000000;
        YValueVariable := 37.000000000000000000;
        YValueLow := 13.000000000000000000;
        YValueClose := 29.000000000000000000;
        YValueHigh := 37.000000000000000000;
        YValueOpen := 25.000000000000000000;
        YValueMedian := 34.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 5.000000000000000000;
        YValue := 129.000000000000000000;
        YValueSecond := 111.000000000000000000;
        YValueVariable := 129.000000000000000000;
        YValueLow := 54.000000000000000000;
        YValueClose := 111.000000000000000000;
        YValueHigh := 129.000000000000000000;
        YValueOpen := 92.000000000000000000;
        YValueMedian := 130.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 6.000000000000000000;
        YValue := 119.000000000000000000;
        YValueSecond := 103.000000000000000000;
        YValueVariable := 119.000000000000000000;
        YValueLow := 73.000000000000000000;
        YValueClose := 86.000000000000000000;
        YValueHigh := 119.000000000000000000;
        YValueOpen := 94.000000000000000000;
        YValueMedian := 118.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 7.000000000000000000;
        YValue := 106.000000000000000000;
        YValueSecond := 87.000000000000000000;
        YValueVariable := 106.000000000000000000;
        YValueLow := 50.000000000000000000;
        YValueClose := 51.000000000000000000;
        YValueHigh := 106.000000000000000000;
        YValueOpen := 55.000000000000000000;
        YValueMedian := 109.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 8.000000000000000000;
        YValue := 121.000000000000000000;
        YValueSecond := 109.000000000000000000;
        YValueVariable := 121.000000000000000000;
        YValueLow := 47.000000000000000000;
        YValueClose := 67.000000000000000000;
        YValueHigh := 121.000000000000000000;
        YValueOpen := 63.000000000000000000;
        YValueMedian := 120.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 9.000000000000000000;
        YValue := 89.000000000000000000;
        YValueSecond := 72.000000000000000000;
        YValueVariable := 89.000000000000000000;
        YValueLow := 49.000000000000000000;
        YValueClose := 49.000000000000000000;
        YValueHigh := 89.000000000000000000;
        YValueOpen := 61.000000000000000000;
        YValueMedian := 88.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 10.000000000000000000;
        YValue := 119.000000000000000000;
        YValueSecond := 106.000000000000000000;
        YValueVariable := 119.000000000000000000;
        YValueLow := 51.000000000000000000;
        YValueClose := 116.000000000000000000;
        YValueHigh := 119.000000000000000000;
        YValueOpen := 68.000000000000000000;
        YValueMedian := 121.000000000000000000;
      end;
      Legend.Fill.Color := clGhostwhite;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -11;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Legend.Stroke.Color := clGray;
      Stroke.Color := 16105559;
      XGrid.Visible := True;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -11;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -11;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -11;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      XValues.Title.Text := 'X-Axis Series 1';
      YGrid.Visible := True;
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -11;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.2f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -11;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.2f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -11;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.Title.Text := 'Y-Axis Series 1';
      Crosshair.XTextStroke.Color := 16105559;
      Crosshair.XTextFill.Color := 16105559;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -11;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 16105559;
      Crosshair.YTextFill.Color := 16105559;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -11;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 16105559;
      Crosshair.VerticalLineStroke.Color := 16105559;
    end;
    with chartWirkungskurven.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      Fill.Color := 5644279;
      LegendText := 'Series 1';
      Labels.Fill.Color := clGhostwhite;
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -11;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.2f';
      Labels.OffsetY := -10.000000000000000000;
      Labels.Stroke.Color := clGray;
      Markers.Fill.Color := 5644279;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 2822268;
      Markers.Visible := True;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      MaxYOffsetPercentage := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Points.Clear;
      with Points.Add do
      begin
        YValue := 81.000000000000000000;
        YValueSecond := 64.000000000000000000;
        YValueVariable := 81.000000000000000000;
        YValueLow := 23.000000000000000000;
        YValueClose := 43.000000000000000000;
        YValueHigh := 81.000000000000000000;
        YValueOpen := 74.000000000000000000;
        YValueMedian := 80.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 1.000000000000000000;
        YValue := 31.000000000000000000;
        YValueSecond := 14.000000000000000000;
        YValueVariable := 31.000000000000000000;
        YValueLow := 4.000000000000000000;
        YValueClose := 19.000000000000000000;
        YValueHigh := 31.000000000000000000;
        YValueOpen := 7.000000000000000000;
        YValueMedian := 33.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 2.000000000000000000;
        YValue := 105.000000000000000000;
        YValueSecond := 92.000000000000000000;
        YValueVariable := 105.000000000000000000;
        YValueLow := 33.000000000000000000;
        YValueClose := 84.000000000000000000;
        YValueHigh := 105.000000000000000000;
        YValueOpen := 53.000000000000000000;
        YValueMedian := 106.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 3.000000000000000000;
        YValue := 105.000000000000000000;
        YValueSecond := 86.000000000000000000;
        YValueVariable := 105.000000000000000000;
        YValueLow := 59.000000000000000000;
        YValueClose := 98.000000000000000000;
        YValueHigh := 105.000000000000000000;
        YValueOpen := 72.000000000000000000;
        YValueMedian := 100.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 4.000000000000000000;
        YValue := 58.000000000000000000;
        YValueSecond := 46.000000000000000000;
        YValueVariable := 58.000000000000000000;
        YValueLow := 22.000000000000000000;
        YValueClose := 42.000000000000000000;
        YValueHigh := 58.000000000000000000;
        YValueOpen := 23.000000000000000000;
        YValueMedian := 56.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 5.000000000000000000;
        YValue := 40.000000000000000000;
        YValueSecond := 27.000000000000000000;
        YValueVariable := 40.000000000000000000;
        YValueLow := 11.000000000000000000;
        YValueClose := 33.000000000000000000;
        YValueHigh := 40.000000000000000000;
        YValueOpen := 39.000000000000000000;
        YValueMedian := 37.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 6.000000000000000000;
        YValue := 33.000000000000000000;
        YValueSecond := 16.000000000000000000;
        YValueVariable := 33.000000000000000000;
        YValueLow := 6.000000000000000000;
        YValueClose := 16.000000000000000000;
        YValueHigh := 33.000000000000000000;
        YValueOpen := 6.000000000000000000;
        YValueMedian := 36.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 7.000000000000000000;
        YValue := 56.000000000000000000;
        YValueSecond := 37.000000000000000000;
        YValueVariable := 56.000000000000000000;
        YValueLow := 13.000000000000000000;
        YValueClose := 13.000000000000000000;
        YValueHigh := 56.000000000000000000;
        YValueOpen := 17.000000000000000000;
        YValueMedian := 60.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 8.000000000000000000;
        YValue := 71.000000000000000000;
        YValueSecond := 54.000000000000000000;
        YValueVariable := 71.000000000000000000;
        YValueLow := 37.000000000000000000;
        YValueClose := 41.000000000000000000;
        YValueHigh := 71.000000000000000000;
        YValueOpen := 42.000000000000000000;
        YValueMedian := 69.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 9.000000000000000000;
        YValue := 98.000000000000000000;
        YValueSecond := 81.000000000000000000;
        YValueVariable := 98.000000000000000000;
        YValueLow := 37.000000000000000000;
        YValueClose := 45.000000000000000000;
        YValueHigh := 98.000000000000000000;
        YValueOpen := 61.000000000000000000;
        YValueMedian := 95.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 10.000000000000000000;
        YValue := 94.000000000000000000;
        YValueSecond := 77.000000000000000000;
        YValueVariable := 94.000000000000000000;
        YValueLow := 50.000000000000000000;
        YValueClose := 56.000000000000000000;
        YValueHigh := 94.000000000000000000;
        YValueOpen := 60.000000000000000000;
        YValueMedian := 93.000000000000000000;
      end;
      Legend.Fill.Color := clGhostwhite;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -11;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Legend.Stroke.Color := clGray;
      Stroke.Color := 5644279;
      Visible := False;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -11;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -11;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -11;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      XValues.Title.Text := 'X-Axis Series 2';
      XValues.Positions := [];
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -11;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.2f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -11;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.2f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -11;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.Title.Text := 'Y-Axis Series 2';
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 5644279;
      Crosshair.XTextFill.Color := 5644279;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -11;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 5644279;
      Crosshair.YTextFill.Color := 5644279;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -11;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 5644279;
      Crosshair.VerticalLineStroke.Color := 5644279;
    end;
    with chartWirkungskurven.Series.Add do
    begin
      AnimationFactor := 4.000000000000000000;
      AutoYRange := arCommonZeroBased;
      Bar.Width := 65.000000000000000000;
      Bar.Spacing := 20.000000000000000000;
      MultiPoint.Width := 65.000000000000000000;
      Pie.Size := 200.000000000000000000;
      Pie.Margins.Left := 10;
      Pie.Margins.Top := 10;
      Pie.Margins.Right := 10;
      Pie.Margins.Bottom := 10;
      Pie.SweepAngle := 360.000000000000000000;
      Fill.Color := 7936771;
      LegendText := 'Series 2';
      Labels.Fill.Color := clGhostwhite;
      Labels.Font.Charset := DEFAULT_CHARSET;
      Labels.Font.Color := clWindowText;
      Labels.Font.Height := -11;
      Labels.Font.Name := 'Segoe UI';
      Labels.Font.Style := [];
      Labels.Format := '%.2f';
      Labels.OffsetY := -10.000000000000000000;
      Labels.Stroke.Color := clGray;
      Markers.Fill.Color := 7936771;
      Markers.Height := 10.000000000000000000;
      Markers.Stroke.Color := 3935746;
      Markers.Visible := True;
      Markers.Width := 10.000000000000000000;
      MaxX := 10.000000000000000000;
      MaxY := 10.000000000000000000;
      MaxYOffsetPercentage := 10.000000000000000000;
      Offset3DX := 15.000000000000000000;
      Offset3DY := 15.000000000000000000;
      Points.Clear;
      with Points.Add do
      begin
        YValue := 88.000000000000000000;
        YValueSecond := 71.000000000000000000;
        YValueVariable := 88.000000000000000000;
        YValueLow := 33.000000000000000000;
        YValueClose := 49.000000000000000000;
        YValueHigh := 88.000000000000000000;
        YValueOpen := 81.000000000000000000;
        YValueMedian := 89.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 1.000000000000000000;
        YValue := 65.000000000000000000;
        YValueSecond := 55.000000000000000000;
        YValueVariable := 65.000000000000000000;
        YValueLow := 23.000000000000000000;
        YValueClose := 25.000000000000000000;
        YValueHigh := 65.000000000000000000;
        YValueOpen := 60.000000000000000000;
        YValueMedian := 64.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 2.000000000000000000;
        YValue := 102.000000000000000000;
        YValueSecond := 84.000000000000000000;
        YValueVariable := 102.000000000000000000;
        YValueLow := 51.000000000000000000;
        YValueClose := 65.000000000000000000;
        YValueHigh := 102.000000000000000000;
        YValueOpen := 76.000000000000000000;
        YValueMedian := 105.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 3.000000000000000000;
        YValue := 59.000000000000000000;
        YValueSecond := 41.000000000000000000;
        YValueVariable := 59.000000000000000000;
        YValueLow := 15.000000000000000000;
        YValueClose := 21.000000000000000000;
        YValueHigh := 59.000000000000000000;
        YValueOpen := 49.000000000000000000;
        YValueMedian := 57.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 4.000000000000000000;
        YValue := 42.000000000000000000;
        YValueSecond := 27.000000000000000000;
        YValueVariable := 42.000000000000000000;
        YValueLow := 16.000000000000000000;
        YValueClose := 22.000000000000000000;
        YValueHigh := 42.000000000000000000;
        YValueOpen := 34.000000000000000000;
        YValueMedian := 38.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 5.000000000000000000;
        YValue := 128.000000000000000000;
        YValueSecond := 110.000000000000000000;
        YValueVariable := 128.000000000000000000;
        YValueLow := 62.000000000000000000;
        YValueClose := 83.000000000000000000;
        YValueHigh := 128.000000000000000000;
        YValueOpen := 63.000000000000000000;
        YValueMedian := 123.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 6.000000000000000000;
        YValue := 49.000000000000000000;
        YValueSecond := 34.000000000000000000;
        YValueVariable := 49.000000000000000000;
        YValueLow := 22.000000000000000000;
        YValueClose := 48.000000000000000000;
        YValueHigh := 49.000000000000000000;
        YValueOpen := 25.000000000000000000;
        YValueMedian := 50.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 7.000000000000000000;
        YValue := 39.000000000000000000;
        YValueSecond := 29.000000000000000000;
        YValueVariable := 39.000000000000000000;
        YValueLow := 12.000000000000000000;
        YValueClose := 30.000000000000000000;
        YValueHigh := 39.000000000000000000;
        YValueOpen := 30.000000000000000000;
        YValueMedian := 35.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 8.000000000000000000;
        YValue := 54.000000000000000000;
        YValueSecond := 38.000000000000000000;
        YValueVariable := 54.000000000000000000;
        YValueLow := 27.000000000000000000;
        YValueClose := 53.000000000000000000;
        YValueHigh := 54.000000000000000000;
        YValueOpen := 41.000000000000000000;
        YValueMedian := 50.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 9.000000000000000000;
        YValue := 20.000000000000000000;
        YValueSecond := 9.000000000000000000;
        YValueVariable := 20.000000000000000000;
        YValueLow := 3.000000000000000000;
        YValueClose := 5.000000000000000000;
        YValueHigh := 20.000000000000000000;
        YValueOpen := 7.000000000000000000;
        YValueMedian := 19.000000000000000000;
      end;
      with Points.Add do
      begin
        XValue := 10.000000000000000000;
        YValue := 105.000000000000000000;
        YValueSecond := 86.000000000000000000;
        YValueVariable := 105.000000000000000000;
        YValueLow := 63.000000000000000000;
        YValueClose := 100.000000000000000000;
        YValueHigh := 105.000000000000000000;
        YValueOpen := 65.000000000000000000;
        YValueMedian := 106.000000000000000000;
      end;
      Legend.Fill.Color := clGhostwhite;
      Legend.Font.Charset := DEFAULT_CHARSET;
      Legend.Font.Color := clWindowText;
      Legend.Font.Height := -11;
      Legend.Font.Name := 'Segoe UI';
      Legend.Font.Style := [];
      Legend.Left := -10.000000000000000000;
      Legend.Stroke.Color := clGray;
      Stroke.Color := 7936771;
      Visible := False;
      XValues.MajorUnit := 1.000000000000000000;
      XValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MajorUnitFont.Color := clWindowText;
      XValues.MajorUnitFont.Height := -11;
      XValues.MajorUnitFont.Name := 'Segoe UI';
      XValues.MajorUnitFont.Style := [];
      XValues.MajorUnitFormat := '%.0f';
      XValues.MajorUnitSpacing := 5.000000000000000000;
      XValues.MajorUnitTickMarkSize := 10.000000000000000000;
      XValues.MajorUnitTickMarkColor := clSilver;
      XValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      XValues.MinorUnitFont.Color := clWindowText;
      XValues.MinorUnitFont.Height := -11;
      XValues.MinorUnitFont.Name := 'Segoe UI';
      XValues.MinorUnitFont.Style := [];
      XValues.MinorUnitFormat := '%.0f';
      XValues.MinorUnitSpacing := 5.000000000000000000;
      XValues.MinorUnitTickMarkSize := 7.000000000000000000;
      XValues.MinorUnitTickMarkColor := clSilver;
      XValues.Title.Font.Charset := DEFAULT_CHARSET;
      XValues.Title.Font.Color := clWindowText;
      XValues.Title.Font.Height := -11;
      XValues.Title.Font.Name := 'Segoe UI';
      XValues.Title.Font.Style := [];
      XValues.Title.TextMargins.Left := 0;
      XValues.Title.TextMargins.Top := 0;
      XValues.Title.TextMargins.Right := 0;
      XValues.Title.TextMargins.Bottom := 0;
      XValues.Title.Text := 'X-Axis Series 3';
      XValues.Positions := [];
      YValues.MajorUnit := 1.000000000000000000;
      YValues.MajorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MajorUnitFont.Color := clWindowText;
      YValues.MajorUnitFont.Height := -11;
      YValues.MajorUnitFont.Name := 'Segoe UI';
      YValues.MajorUnitFont.Style := [];
      YValues.MajorUnitFormat := '%.2f';
      YValues.MajorUnitSpacing := 5.000000000000000000;
      YValues.MajorUnitTickMarkSize := 10.000000000000000000;
      YValues.MajorUnitTickMarkColor := clSilver;
      YValues.MinorUnitFont.Charset := DEFAULT_CHARSET;
      YValues.MinorUnitFont.Color := clWindowText;
      YValues.MinorUnitFont.Height := -11;
      YValues.MinorUnitFont.Name := 'Segoe UI';
      YValues.MinorUnitFont.Style := [];
      YValues.MinorUnitFormat := '%.2f';
      YValues.MinorUnitSpacing := 5.000000000000000000;
      YValues.MinorUnitTickMarkSize := 7.000000000000000000;
      YValues.MinorUnitTickMarkColor := clSilver;
      YValues.Title.Font.Charset := DEFAULT_CHARSET;
      YValues.Title.Font.Color := clWindowText;
      YValues.Title.Font.Height := -11;
      YValues.Title.Font.Name := 'Segoe UI';
      YValues.Title.Font.Style := [];
      YValues.Title.TextMargins.Left := 0;
      YValues.Title.TextMargins.Top := 0;
      YValues.Title.TextMargins.Right := 0;
      YValues.Title.TextMargins.Bottom := 0;
      YValues.Title.Text := 'Y-Axis Series 3';
      YValues.Positions := [];
      Crosshair.XTextStroke.Color := 7936771;
      Crosshair.XTextFill.Color := 7936771;
      Crosshair.XTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.XTextFont.Color := clWhite;
      Crosshair.XTextFont.Height := -11;
      Crosshair.XTextFont.Name := 'Segoe UI';
      Crosshair.XTextFont.Style := [];
      Crosshair.YTextStroke.Color := 7936771;
      Crosshair.YTextFill.Color := 7936771;
      Crosshair.YTextFont.Charset := DEFAULT_CHARSET;
      Crosshair.YTextFont.Color := clWhite;
      Crosshair.YTextFont.Height := -11;
      Crosshair.YTextFont.Name := 'Segoe UI';
      Crosshair.YTextFont.Style := [];
      Crosshair.HorizontalLineStroke.Color := 7936771;
      Crosshair.VerticalLineStroke.Color := 7936771;
    end;
    chartWirkungskurven.Title.Fill.Kind := gfkNone;
    chartWirkungskurven.Title.Fill.Color := clGhostwhite;
    chartWirkungskurven.Title.Stroke.Color := clGray;
    chartWirkungskurven.Title.Font.Charset := DEFAULT_CHARSET;
    chartWirkungskurven.Title.Font.Color := clWindowText;
    chartWirkungskurven.Title.Font.Height := -11;
    chartWirkungskurven.Title.Font.Name := 'Segoe UI';
    chartWirkungskurven.Title.Font.Style := [fsBold];
    chartWirkungskurven.Title.Height := 35.000000000000000000;
    chartWirkungskurven.Title.TextMargins.Left := 3;
    chartWirkungskurven.Title.TextMargins.Top := 3;
    chartWirkungskurven.Title.TextMargins.Right := 3;
    chartWirkungskurven.Title.TextMargins.Bottom := 3;
    chartWirkungskurven.Title.Text := 'Wirkungskurven';
    chartWirkungskurven.XAxis.Fill.Kind := gfkNone;
    chartWirkungskurven.XAxis.Fill.Color := clGhostwhite;
    chartWirkungskurven.XAxis.Stroke.Color := clGray;
    chartWirkungskurven.XAxis.Height := 35.000000000000000000;
    chartWirkungskurven.YAxis.Fill.Kind := gfkNone;
    chartWirkungskurven.YAxis.Fill.Color := clGhostwhite;
    chartWirkungskurven.YAxis.Stroke.Color := clGray;
    chartWirkungskurven.YAxis.Width := 35.000000000000000000;
    chartWirkungskurven.DefaultLoadOptions.XValuesFormatString := '%.0f';
    chartWirkungskurven.DefaultLoadOptions.YValuesFormatString := '%.2f';
    chartWirkungskurven.DefaultLoadOptions.MaxYOffsetPercentage := 5.000000000000000000;
    chartWirkungskurven.Align := alClient;
    chartWirkungskurven.TabOrder := 2;
  finally
    WaitMessage.AfterLoadDFMValues;
    pnChart.AfterLoadDFMValues;
    pnChartDataGrid.AfterLoadDFMValues;
    strgWirkungsKurvenData.AfterLoadDFMValues;
    pnKurvenAuswahl.AfterLoadDFMValues;
    lbKurvenauswahl.AfterLoadDFMValues;
    chartWirkungskurven.AfterLoadDFMValues;
  end;
end;

end.